/**
 * StagingWatermark Component
 * 
 * Displays a watermark across all pages when running on the staging environment
 * to help distinguish staging from production and avoid confusion.
 * 
 * The watermark is:
 * - Semi-transparent so it doesn't obstruct content
 * - Non-interactive (pointer-events: none)
 * - Positioned fixed to stay visible during scrolling
 * - Rotated diagonally for clear identification
 * - Only visible on staging environment
 */

import { shouldShowEnvironmentWatermark, getEnvironmentLabel } from '@/utils/environment';
import '@/styles/StagingWatermark.scss';

const StagingWatermark = () => {
    // Only render if we're on staging environment
    if (!shouldShowEnvironmentWatermark()) {
        return null;
    }

    return (
        <div className="staging-watermark" aria-hidden="true">
            <div className="staging-watermark-text">
                {getEnvironmentLabel()}
            </div>
        </div>
    );
};

export default StagingWatermark;
